import { render, staticRenderFns } from "./PreActivity.vue?vue&type=template&id=95806d64&scoped=true"
import script from "./PreActivity.vue?vue&type=script&lang=js"
export * from "./PreActivity.vue?vue&type=script&lang=js"
import style0 from "./PreActivity.vue?vue&type=style&index=0&id=95806d64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95806d64",
  null
  
)

export default component.exports